import unscheduleMenuItem from "components/common/Scheduler//unscheduleMenuItem";
import flagsMenuItem from "components/common/Scheduler/flagsMenuItem";
import teardownTimeMenuItem from "components/common/Scheduler/teardownTimeMenuItem";
import isEmpty from "lodash/isEmpty";

export default function workBlockContextMenu({
  blockData,
  canPublishWorkBlock,
  items,
  onFullyScheduleWorkOrder,
  onOpenEditWorkBlock,
  onPublishWorkBlock,
  onScheduleTeardownTime,
  onSplitWorkBlockAcrossShifts,
  onUnscheduleTeardownTime,
  onUpdateWorkOrder,
  onViewNotesPopUp,
  openWorkOrderDetails,
  teardownTimes,
  unscheduleBlock,
  unscheduleWorkOrder,
}) {
  const { block } = blockData;

  const viewWorkOrderDetails = ({ eventRecord }) => {
    const { data } = eventRecord;

    openWorkOrderDetails(data.block.workOrder.id);
  };

  const handleEditTeardownTime = ({ eventRecord }) => {
    onOpenEditWorkBlock(eventRecord);
    setTimeout(() => {
      document.getElementById("teardown-time-label")?.focus();
    }, 0);
  };

  const splitWorkBlockAcrossShifts = {
    cls: "pendo-override-production-rate-context-menu-item",
    name: "split-across-shifts",
    onItem: onSplitWorkBlockAcrossShifts,
    text: "Split across shifts",
  };

  const editWorkOrderNotesMenuItem = {
    cls: "pendo-edit-notes-context-menu-item",
    name: "edit-work-order-notes",
    onItem: onViewNotesPopUp,
    text: "Edit work order notes",
  };

  const fullyScheduleWorkOrderMenuItem = {
    cls: "pendo-fully-schedule-context-menu-item",
    name: "fully-schedule",
    onItem: onFullyScheduleWorkOrder,
    text: "Fully schedule",
  };

  const publishWorkBlock = {
    cls: "pendo-publish-work-block-context-menu-item",
    name: "publish",
    onItem: onPublishWorkBlock,
    text: "Publish",
  };

  return {
    deleteEvent: false,
    edit: {
      ...items.editEvent,
      cls: "pendo-edit-work-block-context-menu-item",
      icon: false,
      text: "Edit work block",
    },
    editEvent: false,
    editWorkOrderNotes: block.lockedOnSchedule ? false : editWorkOrderNotesMenuItem,
    flags: flagsMenuItem(onUpdateWorkOrder),
    fullyScheduleWorkOrder: block.lockedOnSchedule ? false : fullyScheduleWorkOrderMenuItem,
    publishWorkBlock: canPublishWorkBlock ? publishWorkBlock : false,
    scheduleTeardownTime:
      !block.lockedOnSchedule && isEmpty(teardownTimes)
        ? {
            cls: "pendo-schedule-unconfigured-teardown-time-context-menu-item",
            name: "schedule-teardown-time",
            onItem: handleEditTeardownTime,
            text: block.teardownTimeDuration === 0 ? "Schedule teardown time" : "Edit teardown time",
          }
        : false,
    scheduleTeardownTimeMenu:
      !block.lockedOnSchedule && !isEmpty(teardownTimes)
        ? teardownTimeMenuItem({
            onCustomTeardownTime: handleEditTeardownTime,
            onScheduleTeardownTime,
            teardownTimes,
            workBlock: block,
          })
        : false,
    splitWorkBlockAcrossShifts,
    unschedule: unscheduleMenuItem({ unscheduleBlock, unscheduleWorkOrder }),
    unscheduleTeardownTime:
      !block.lockedOnSchedule && block.teardownTimeDuration > 0
        ? {
            cls: "pendo-unschedule-teardown-time-context-menu-item",
            name: "unschedule-teardown-time",
            onItem: onUnscheduleTeardownTime,
            text: "Unschedule teardown time",
          }
        : false,
    viewWorkOrderDetails: {
      cls: "pendo-view-work-order-details-context-menu-item",
      name: "view-work-order-details",
      onItem: viewWorkOrderDetails,
      text: "View work order details",
    },
  };
}
